import React from 'react';
import IconCard from '@portal/components/IconCard/IconCard';
import { getRouteStackPath } from '@portal/config/routes';

import ReceiveIcon from '@portal/assets/svg/home-buttons/ic_file_upload.svg?react';
import { translate } from '@portal/services/i18n';
import { PaymentMode } from '@portal/models/enumerators';
import useReduxState from '@portal/hooks/useReduxState';

const PayableButtons = ({
  openMaintenance,
}: {
  openMaintenance: () => void;
}) => {
  const {
    settings: { remoteConfig },
  } = useReduxState();

  return (
    <IconCard
      text={translate('PAGES.PAYMENT.ACCOUNT_PAYABLE.BUTTONS.FILE')}
      icon={
        <ReceiveIcon
          className="account-payable__container__options__icon-card__icon"
          width={30}
          height={30}
        />
      }
      link={
        remoteConfig?.disableCashOut
          ? undefined
          : getRouteStackPath('FILES_HANDLER', 'GENERATE_BY_FILE')
      }
      linkData={{
        mode: PaymentMode.PAYABLE,
      }}
      onClick={
        remoteConfig?.disableCashOut ? () => openMaintenance() : undefined
      }
    />
  );
};

export default PayableButtons;
